import React from 'react';
import DsSelect from '../../common/DsSelect';

export default function EventTaskDetailSubtasks({ view }) {
  const {
    eventSubtaskInlineEdit,
    eventTaskAssignableAdmins,
    eventTaskCanEdit,
    eventTaskCreatingSubtask,
    eventTaskDetailSubtasks,
    eventTaskNewSubtaskAssigneeId,
    eventTaskNewSubtaskAssigneeLabel,
    eventTaskNewSubtaskDueOn,
    eventTaskNewSubtaskInlineEditField,
    eventTaskNewSubtaskTitle,
    eventTaskUpdatingId,
    formatAdminDisplay,
    formatDate,
    getEventTaskAssigneeLabel,
    getEventTaskPrimaryAssignee,
    handleCreateEventSubtask,
    handleToggleEventTaskStatus,
    isTaskDoneStatus,
    normalizeTaskPriority,
    patchEventTaskInline,
    setEventSubtaskInlineEdit,
    setEventTaskNewSubtaskAssigneeId,
    setEventTaskNewSubtaskDueOn,
    setEventTaskNewSubtaskInlineEditField,
    setEventTaskNewSubtaskTitle,
  } = view;

  return (
    <>
                        <div className="event-task-detail-modal__subtasks">
                          <div className="event-task-detail-modal__subtasksHead">
                            <h4>
                              サブタスク
                              <small>
                                {eventTaskDetailSubtasks.filter((subtask) =>
                                  isTaskDoneStatus(subtask.status)
                                ).length}
                                /
                                {eventTaskDetailSubtasks.length}
                              </small>
                            </h4>
                          </div>

                          {eventTaskDetailSubtasks.length === 0 ? (
                            <p className="event-task-detail-modal__emptyText">サブタスクはまだありません。</p>
                          ) : (
                            <ul className="event-task-detail-modal__subtaskList">
                              {eventTaskDetailSubtasks.map((subtask) => {
                                const assigneeLabel = getEventTaskAssigneeLabel(subtask);
                                const currentAssigneeId = String(
                                  getEventTaskPrimaryAssignee(subtask)?.adminUserId || ''
                                );
                                return (
                                  <li key={subtask.id}>
                                    <div className="event-task-detail-modal__subtaskMainRow">
                                      <button
                                        type="button"
                                        className={`event-task-detail-modal__subtaskDoneBtn ${
                                          isTaskDoneStatus(subtask.status) ? 'is-done' : ''
                                        } is-priority-${normalizeTaskPriority(subtask.priority)}`}
                                        onClick={() => {
                                          void handleToggleEventTaskStatus(subtask);
                                        }}
                                        disabled={!eventTaskCanEdit || eventTaskUpdatingId === subtask.id}
                                        aria-label={
                                          isTaskDoneStatus(subtask.status)
                                            ? '未着手に戻す'
                                            : '完了にする'
                                        }
                                      >
                                        <i className="fa-solid fa-check" />
                                      </button>
                                      <div className="event-task-detail-modal__subtaskTitle">
                                        <span>{subtask.title || 'タイトル未設定'}</span>
                                      </div>
                                    </div>
                                    <div className="event-task-detail-modal__subtaskMetaRow">
                                      <div className="event-task-detail-modal__subtaskMetaField">
                                        {eventSubtaskInlineEdit.taskId === subtask.id &&
                                        eventSubtaskInlineEdit.field === 'due' &&
                                        eventTaskCanEdit ? (
                                          <input
                                            type="date"
                                            autoFocus
                                            className="event-task-detail-modal__subtaskDueInput"
                                            value={subtask.dueOn ? String(subtask.dueOn).slice(0, 10) : ''}
                                            onBlur={() =>
                                              setEventSubtaskInlineEdit({ taskId: '', field: '' })
                                            }
                                            onChange={(e) => {
                                              setEventSubtaskInlineEdit({ taskId: '', field: '' });
                                              void patchEventTaskInline(
                                                subtask.id,
                                                { dueOn: e.target.value || null },
                                                'サブタスク期限を更新しました。'
                                              );
                                            }}
                                            disabled={!eventTaskCanEdit || eventTaskUpdatingId === subtask.id}
                                            aria-label="サブタスク期限"
                                          />
                                        ) : (
                                          <button
                                            type="button"
                                            className="event-task-detail-modal__subtaskMetaTrigger event-task-detail-modal__subtaskMetaTrigger--due"
                                            onClick={() => {
                                              if (!eventTaskCanEdit) return;
                                              setEventSubtaskInlineEdit({
                                                taskId: subtask.id,
                                                field: 'due',
                                              });
                                            }}
                                            disabled={!eventTaskCanEdit || eventTaskUpdatingId === subtask.id}
                                          >
                                            {subtask.dueOn ? formatDate(subtask.dueOn) : '年 / 月 / 日'}
                                          </button>
                                        )}
                                      </div>
                                      <div className="event-task-detail-modal__subtaskMetaField">
                                        {eventSubtaskInlineEdit.taskId === subtask.id &&
                                        eventSubtaskInlineEdit.field === 'assignee' &&
                                        eventTaskCanEdit ? (
                                          <DsSelect
                                            autoFocus
                                            className="event-task-detail-modal__subtaskAssigneeSelect"
                                            value={currentAssigneeId}
                                            onBlur={() =>
                                              setEventSubtaskInlineEdit({ taskId: '', field: '' })
                                            }
                                            onChange={(e) => {
                                              const nextAssigneeId = String(e.target.value || '');
                                              setEventSubtaskInlineEdit({ taskId: '', field: '' });
                                              void patchEventTaskInline(
                                                subtask.id,
                                                {
                                                  assigneeIds: nextAssigneeId
                                                    ? [Number(nextAssigneeId)]
                                                    : [],
                                                },
                                                'サブタスク担当者を更新しました。'
                                              );
                                            }}
                                            disabled={!eventTaskCanEdit || eventTaskUpdatingId === subtask.id}
                                            aria-label="サブタスク担当者"
                                          >
                                            <option value="">未割当</option>
                                            {eventTaskAssignableAdmins.map((admin) => (
                                              <option key={admin.adminUserId} value={String(admin.adminUserId)}>
                                                {formatAdminDisplay(admin)}
                                              </option>
                                            ))}
                                          </DsSelect>
                                        ) : (
                                          <button
                                            type="button"
                                            className="event-task-detail-modal__subtaskMetaTrigger event-task-detail-modal__subtaskMetaTrigger--assignee"
                                            onClick={() => {
                                              if (!eventTaskCanEdit) return;
                                              setEventSubtaskInlineEdit({
                                                taskId: subtask.id,
                                                field: 'assignee',
                                              });
                                            }}
                                            disabled={!eventTaskCanEdit || eventTaskUpdatingId === subtask.id}
                                          >
                                            {assigneeLabel}
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          )}

                          {eventTaskCanEdit ? (
                            <div className="event-task-detail-modal__subtaskCreate">
                              <div className="event-task-detail-modal__subtaskCreateMain">
                                <input
                                  type="text"
                                  className="event-task-detail-modal__subtaskCreateTitleInput"
                                  value={eventTaskNewSubtaskTitle}
                                  onChange={(e) => setEventTaskNewSubtaskTitle(e.target.value)}
                                  placeholder="サブタスク名"
                                  onKeyDown={(e) => {
                                    if (e.key !== 'Enter') return;
                                    e.preventDefault();
                                    void handleCreateEventSubtask();
                                  }}
                                  disabled={eventTaskCreatingSubtask}
                                />
                              </div>
                              <div className="event-task-detail-modal__subtaskCreateMeta">
                                <div className="event-task-detail-modal__subtaskMetaField">
                                  {eventTaskNewSubtaskInlineEditField === 'due' &&
                                  eventTaskCanEdit ? (
                                    <input
                                      type="date"
                                      autoFocus
                                      className="event-task-detail-modal__subtaskDueInput"
                                      value={eventTaskNewSubtaskDueOn}
                                      onBlur={() => setEventTaskNewSubtaskInlineEditField('')}
                                      onChange={(e) => {
                                        setEventTaskNewSubtaskDueOn(e.target.value || '');
                                        setEventTaskNewSubtaskInlineEditField('');
                                      }}
                                      disabled={eventTaskCreatingSubtask}
                                      aria-label="新規サブタスク期限"
                                    />
                                  ) : (
                                    <button
                                      type="button"
                                      className="event-task-detail-modal__subtaskMetaTrigger event-task-detail-modal__subtaskMetaTrigger--due"
                                      onClick={() => {
                                        if (!eventTaskCanEdit) return;
                                        setEventTaskNewSubtaskInlineEditField('due');
                                      }}
                                      disabled={eventTaskCreatingSubtask}
                                    >
                                      {eventTaskNewSubtaskDueOn
                                        ? formatDate(eventTaskNewSubtaskDueOn)
                                        : '年 / 月 / 日'}
                                    </button>
                                  )}
                                </div>
                                <div className="event-task-detail-modal__subtaskCreateAssignee">
                                  <div className="event-task-detail-modal__subtaskMetaField">
                                    {eventTaskNewSubtaskInlineEditField === 'assignee' &&
                                    eventTaskCanEdit ? (
                                      <DsSelect
                                        autoFocus
                                        className="event-task-detail-modal__subtaskAssigneeSelect"
                                        value={eventTaskNewSubtaskAssigneeId}
                                        onBlur={() => setEventTaskNewSubtaskInlineEditField('')}
                                        onChange={(e) => {
                                          setEventTaskNewSubtaskAssigneeId(String(e.target.value || ''));
                                          setEventTaskNewSubtaskInlineEditField('');
                                        }}
                                        disabled={eventTaskCreatingSubtask}
                                        aria-label="新規サブタスク担当者"
                                      >
                                        <option value="">未割当</option>
                                        {eventTaskAssignableAdmins.map((admin) => (
                                          <option key={admin.adminUserId} value={String(admin.adminUserId)}>
                                            {formatAdminDisplay(admin)}
                                          </option>
                                        ))}
                                      </DsSelect>
                                    ) : (
                                      <button
                                        type="button"
                                        className="event-task-detail-modal__subtaskMetaTrigger event-task-detail-modal__subtaskMetaTrigger--assignee"
                                        onClick={() => {
                                          if (!eventTaskCanEdit) return;
                                          setEventTaskNewSubtaskInlineEditField('assignee');
                                        }}
                                        disabled={eventTaskCreatingSubtask}
                                      >
                                        {eventTaskNewSubtaskAssigneeLabel}
                                      </button>
                                    )}
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      void handleCreateEventSubtask();
                                    }}
                                    disabled={eventTaskCreatingSubtask || !eventTaskNewSubtaskTitle.trim()}
                                  >
                                    {eventTaskCreatingSubtask ? '追加中...' : '追加'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
    </>
  );
}
